import React, { FC } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentWrapper from '../../ui/Content/Content';
import { Section, SectionDescription, SectionHeader, Sections, Wrapper } from './AcademyAdvantages.elements';

interface AcademyAdvantagesProps { }

const AcademyAdvantagesTemplate: FC<AcademyAdvantagesProps> = () => {
    const { t } = useTranslation();

    return (
        <ContentWrapper withPadding mobileSidePadding={20}>
            <TitleTemplate tagType={TitleTagTypes.H2} isBlack>
                {t('academy.title')}
            </TitleTemplate>
            <Wrapper>
                <Sections>
                    <Section>
                        <SectionHeader>
                            <IconTemplate name={Icons.CheckThin} />
                            {t('academy.advantages.section1.label')}
                        </SectionHeader>
                        <SectionDescription dangerouslySetInnerHTML={{ __html: t('academy.advantages.section1.description') }}></SectionDescription>
                    </Section>
                    <Section>
                        <SectionHeader>
                            <IconTemplate name={Icons.CheckThin} />
                            {t('academy.advantages.section3.label')}
                        </SectionHeader>
                        <SectionDescription dangerouslySetInnerHTML={{ __html: t('academy.advantages.section3.description') }}></SectionDescription>
                    </Section>
                    <Section>
                        <SectionHeader>
                            <IconTemplate name={Icons.CheckThin} />
                            {t('academy.advantages.section5.label')}
                        </SectionHeader>
                        <SectionDescription dangerouslySetInnerHTML={{ __html: t('academy.advantages.section5.description') }}></SectionDescription>
                    </Section>
                </Sections>
                <Sections>
                    <Section>
                        <SectionHeader>
                            <IconTemplate name={Icons.CheckThin} />
                            {t('academy.advantages.section4.label')}
                        </SectionHeader>
                        <SectionDescription dangerouslySetInnerHTML={{ __html: t('academy.advantages.section4.description') }}></SectionDescription>
                    </Section>
                    <Section>
                        <SectionHeader>
                            <IconTemplate name={Icons.CheckThin} />
                            {t('academy.advantages.section2.label')}
                        </SectionHeader>
                        <SectionDescription dangerouslySetInnerHTML={{ __html: t('academy.advantages.section2.description') }}></SectionDescription>
                    </Section>
                    <Section>
                        <SectionHeader>
                            <IconTemplate name={Icons.CheckThin} />
                            {t('academy.advantages.section6.label')}
                        </SectionHeader>
                        <SectionDescription dangerouslySetInnerHTML={{ __html: t('academy.advantages.section6.description') }}></SectionDescription>
                    </Section>
                </Sections>
            </Wrapper>
        </ContentWrapper>
    );
};
export default AcademyAdvantagesTemplate;
